import {
    Button,
    Checkbox,
    FormHelperText,
    IconButton,
    MenuItem,
    MuiThemeProvider,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField
} from '@material-ui/core';
import cs from 'classnames';
import * as actions from 'components/TrustCenter/store/actions';
import agreementCSS from 'components/TrustCenter/ProviderDetails/ProviderDetail.module.css';
import { format } from 'date-fns';
import Auxiliary from 'hoc/Auxiliary';
import React, { useEffect, useState } from 'react';
import Downshift from 'downshift';
import deburr from 'lodash/deburr';
import { DatePicker } from 'material-ui-pickers';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import css from '../AddTruck/AddTruck.module.css';
import { CHECKBOX_STYLE, DEFAULT_THEME } from 'theme/CommonTheme';
import { TABLE_THEME, TABLE_THEME_ALT } from 'components/TrustCenter/TrustCenterMuiTheme';
import baseCSS from 'components/TrustCenter/TrustCenter.module.css';
import { isEmptyList, isNotBlank, isNotEmptyList } from 'components/Common/Utils/StringUtils';
import TDialog from 'components/UI/Dialog/TDialog';
import {
    PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME,
    PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME
} from 'components/UI/Button/ButtonMuiTheme';
import {
    convertLocalDateString,
    convertLocalDateTimePickerFormatStringFromDateObject,
    convertToDateTimeString,
    convertToUTCDateTimeString,
    isEqualDate
} from 'components/Common/Utils/DateUtils';
import get from 'lodash/get';
import { isOtherGroupInEditMode } from '../../TMS/Utils/TMSUtils';
import {
    validateDeleteAccess,
    validateWriteAccess
} from 'components/Common/ResourceAccessValidation/ResourceAccessValidation';
import * as Constants from 'constants/Constants';

const errorFieldProperties = {
    truckNumber: {
        isInvalid: false,
        message: ''
    },
    enabled_from: {
        isInvalid: false,
        message: ''
    },
    expires_on: {
        isInvalid: false,
        message: ''
    }
};

const TruckAgreements = (props) => {
    const {
        newTruckAgreement,
        updateNewTruck,
        agreements,
        groupName,
        searchText,
        mobilityData,
        editedAgreements,
        updateEditedAgreements,
        deleteAgreement,
        deletedAgreements,
        updateDeletedAgreements,
        startDate,
        endDate,
        toggleAgreementEditStatus,
        setShowDeleteAll,
        executeDelete,
        setExecuteDelete,
        discardChanges,
        resetDiscardFlag,
        newAgreementGroup,
        existingAgreementGroup,
        newShipperAgreement,
        isAgreementInEditMode,
        changeStartDate,
        changeEndDate,
        setChangeStartDate,
        setChangeEndDate,
        disableOtherOperation,
        sidebarResource,
        hideLocalElement,
        setStartDate,
        setEndDate,
        initialStartDate,
        initialEndDate
    } = props;

    const [page, setPage] = useState(0);

    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [newTruckEditRowMap, setNewTruckEditRowMap] = useState([]);

    const [newTruckEditableAgreement, setNewTruckEditableAgreement] = useState([]);

    const [totalNewTruckAgreements, setTotalNewTruckAgreements] = useState([]);

    const [showSearchTruck, setShowSearchTruck] = useState(false);

    const [userEditedTrucks, setUserEditedTrucks] = useState({});

    const [selectedItem, setSelectedItem] = useState('');

    let isValidDefaultStartDate = true;

    let isValidDefaultEndDate = true;

    const [editedIndex, setEditedIndex] = useState(-1);

    const [currentSelected, setCurrentSelected] = useState('');

    const [showSuggestions, setShowSuggestions] = useState(false);

    const [openConfimation, setOpenConfimation] = useState(false);

    const [deleteIndex, setDeleteIndex] = useState(-1);

    const [disableTick, setDisableTick] = useState(false);

    const [deleteAllVehicles, setDeleteAllVehicles] = useState(false);

    const [isEdited, setIsEdited] = useState(false);
    const [emptyRows, setEmptyRows] = useState(
        rowsPerPage - Math.min(rowsPerPage, newTruckAgreement.length - page * rowsPerPage)
    );

    const [errorText, setErrorText] = useState({
        truckNumber: '',
        timing: '',
        duplicateTrucks: ''
    });

    const [deleteNewTruckList, setDeleteNewTruckList] = useState([]);

    const [deleteExistingTruckList, setDeleteExistingTruckList] = useState([]);

    const errorFieldObject = {
        truckNumber: {
            isInvalid: false,
            message: ''
        },
        startDate: {
            isInvalid: false,
            message: ''
        },
        endDate: {
            isInvalid: false,
            message: ''
        }
    };

    const [errorField, setErrorField] = useState(JSON.parse(JSON.stringify(errorFieldProperties)));

    const [errorFieldList, setErrorFieldList] = useState([]);

    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);

    const [isDeleteAccessGranted, setDeleteAccessGranted] = useState(false);

    useEffect(() => {
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.TRUSTCENTER_RESOURCE,
                Constants.TRUSTCENTER_FEATURE
            )
        );

        setDeleteAccessGranted(
            validateDeleteAccess(
                sidebarResource,
                Constants.TRUSTCENTER_RESOURCE,
                Constants.TRUSTCENTER_FEATURE
            )
        );
    }, [sidebarResource]);

    useEffect(() => {
        let tempEditRowMap = [];
        let totalEditRowMap = [...newTruckEditRowMap];

        let tempErrorFieldList = [];
        let totalErrorFieldList = [...errorFieldList];

        if (isNotEmptyList(agreements[groupName])) {
            totalEditRowMap = totalEditRowMap.splice(
                newTruckEditRowMap.length - agreements[groupName].length,
                agreements[groupName].length
            );
            totalErrorFieldList = totalErrorFieldList.splice(
                newTruckEditRowMap.length - agreements[groupName].length,
                agreements[groupName].length
            );
        }

        let totalList = [];
        if (isNotBlank(groupName)) {
            if (isNotEmptyList(newTruckAgreement)) {
                totalList = JSON.parse(JSON.stringify(newTruckAgreement));
                newTruckAgreement.forEach((item, index) => {
                    tempEditRowMap.push(false);
                    tempErrorFieldList.push({ ...errorFieldObject });
                });
            }
            if (isNotEmptyList(agreements[groupName])) {
                if (
                    totalNewTruckAgreements.length > newTruckAgreement.length &&
                    isNotEmptyList(Object.keys(userEditedTrucks))
                ) {
                    let startIndex = 0;
                    let existingAgreements = totalNewTruckAgreements.filter((agreement) => {
                        return isNotBlank(agreement.id);
                    });
                    if (isNotEmptyList(existingAgreements)) {
                        startIndex = totalNewTruckAgreements.length - existingAgreements.length;
                    }
                    totalList = totalList.concat(
                        totalNewTruckAgreements.splice(startIndex, existingAgreements.length)
                    );
                } else {
                    totalList = totalList.concat(JSON.parse(JSON.stringify(agreements[groupName])));
                }
            }
        }
        let tempDeleteNewTruckList = [...deleteNewTruckList];
        if (isNotEmptyList(deleteNewTruckList) && isNotEmptyList(newTruckAgreement)) {
            tempDeleteNewTruckList = tempDeleteNewTruckList.filter((seletedAgreementIndex) => {
                return seletedAgreementIndex < newTruckAgreement.length - 1;
            });
            totalList.forEach((agreement, index) => {
                if (deleteExistingTruckList.includes(agreement.id)) {
                    tempDeleteNewTruckList.push(index);
                }
            });
        }
        tempEditRowMap = tempEditRowMap.concat(totalEditRowMap);
        tempErrorFieldList = tempErrorFieldList.concat(totalErrorFieldList);
        setNewTruckEditRowMap([...tempEditRowMap]);
        setTotalNewTruckAgreements(JSON.parse(JSON.stringify(totalList)));
        setDeleteNewTruckList([...tempDeleteNewTruckList]);
        setNewTruckEditableAgreement([...totalList]);
        setErrorFieldList([...tempErrorFieldList]);
        setEmptyRows(rowsPerPage - Math.min(rowsPerPage, totalList.length - page * rowsPerPage));
    }, [newTruckAgreement]);

    useEffect(() => {
        let tempEditRowMap = [];
        let tempErrorFieldList = [];
        if (isNotEmptyList(deletedAgreements)) {
            tempEditRowMap = [...newTruckEditRowMap];
            tempErrorFieldList = [...errorFieldList];
            let tempTotalNewTruckAgreements = JSON.parse(JSON.stringify(totalNewTruckAgreements));
            let tempNewTruckEditableAgreement = JSON.parse(
                JSON.stringify(newTruckEditableAgreement)
            );
            let tempEditedAgreement = { ...editedAgreements };
            let tempUserEditedTrucks = JSON.parse(JSON.stringify(userEditedTrucks));
            if (isNotEmptyList(tempEditedAgreement[groupName])) {
                tempEditedAgreement[groupName] = tempEditedAgreement[groupName].filter(
                    (editedAgreement) => {
                        return !deletedAgreements.includes(editedAgreement.id);
                    }
                );
            }
            let tempDeleteNewTruckList = [...deleteNewTruckList];
            let tempDeleteExitingTruckList = [...deleteExistingTruckList];
            if (executeDelete) {
                tempDeleteNewTruckList = [];
                tempDeleteExitingTruckList = [];
                setExecuteDelete(false);
                setDeleteNewTruckList([...tempDeleteNewTruckList]);
                setDeleteExistingTruckList([...tempDeleteExitingTruckList]);
            }
            deletedAgreements.forEach((deletedAgreement) => {
                tempTotalNewTruckAgreements.forEach((agreementInfo, index) => {
                    if (agreementInfo.id === deletedAgreement) {
                        tempTotalNewTruckAgreements.splice(index, 1);
                        tempNewTruckEditableAgreement.splice(index, 1);
                        tempEditRowMap.splice(index, 1);
                        tempErrorFieldList.splice(index, 1);
                        if (isNotEmptyList(tempDeleteNewTruckList)) {
                            tempDeleteNewTruckList = tempDeleteNewTruckList.filter(
                                (seletedAgreementIndex) => {
                                    return seletedAgreementIndex !== index;
                                }
                            );
                            tempDeleteNewTruckList = tempDeleteNewTruckList.map(
                                (seletedAgreementIndex) => {
                                    if (seletedAgreementIndex > index) {
                                        return seletedAgreementIndex - 1;
                                    }
                                    return seletedAgreementIndex;
                                }
                            );
                        }
                        delete tempUserEditedTrucks[deletedAgreement];
                    }
                });
            });
            if (isEmptyList(tempDeleteNewTruckList)) {
                setShowDeleteAll(false);
            } else {
                tempDeleteNewTruckList.forEach((selectedIndex) => {});
            }

            tempDeleteExitingTruckList = tempDeleteExitingTruckList.filter((seletedAgreement) => {
                return !deletedAgreements.includes(seletedAgreement);
            });
            setDeleteNewTruckList([...tempDeleteNewTruckList]);
            setDeleteExistingTruckList([...tempDeleteExitingTruckList]);
            setNewTruckEditRowMap([...tempEditRowMap]);
            setUserEditedTrucks({ ...tempUserEditedTrucks });
            setErrorFieldList([...tempErrorFieldList]);
            setTotalNewTruckAgreements([...tempTotalNewTruckAgreements]);
            setNewTruckEditableAgreement([...tempNewTruckEditableAgreement]);
            updateEditedAgreements({ ...tempEditedAgreement });
            updateDeletedAgreements([]);
            const totalPage = Math.ceil(tempTotalNewTruckAgreements.length / rowsPerPage) - 1;
            let modifiedPage = page;
            if (totalPage < page) {
                setPage(totalPage);
                modifiedPage = totalPage;
            }
            setPage(modifiedPage);
            setEmptyRows(
                rowsPerPage -
                    Math.min(
                        rowsPerPage,
                        tempTotalNewTruckAgreements.length - modifiedPage * rowsPerPage
                    )
            );
        } else if (isNotBlank(groupName) && agreements[groupName] !== undefined) {
            get(agreements, `["${groupName}"]`, []).forEach(() => {
                tempEditRowMap.push(false);
                tempErrorFieldList.push({ ...errorFieldObject });
            });
            setNewTruckEditRowMap([...tempEditRowMap]);
            setErrorFieldList([...tempErrorFieldList]);
            let totalAgreements = JSON.parse(
                JSON.stringify(get(agreements, `["${groupName}"]`, []))
            );

            setNewTruckEditableAgreement(
                JSON.parse(JSON.stringify(get(agreements, `["${groupName}"]`, [])))
            );
            setEmptyRows(
                rowsPerPage - Math.min(rowsPerPage, totalAgreements.length - page * rowsPerPage)
            );
        }
        setTotalNewTruckAgreements(
            agreements[groupName] ? JSON.parse(JSON.stringify(agreements[groupName])) : []
        );
    }, [agreements]);

    useEffect(() => {
        if (
            discardChanges &&
            (editedAgreements.hasOwnProperty(groupName) ||
                isNotEmptyList(newTruckAgreement) ||
                editedIndex >= 0)
        ) {
            updateEditedAgreements({});
            let tempTotalNewTruckAgreements = [];
            let tempNewTruckEditableAgreement = [];

            setEditedIndex(-1);
            toggleAgreementEditStatus({});
            let tempErrorFieldList = [];

            let startIndex = 0;
            if (isNotEmptyList(newTruckAgreement)) {
                startIndex = newTruckAgreement.length;
            }
            get(agreements, `["${groupName}"]`, [])?.forEach((agreement) => {
                tempTotalNewTruckAgreements.push(JSON.parse(JSON.stringify(agreement)));
                tempNewTruckEditableAgreement.push(JSON.parse(JSON.stringify(agreement)));
                tempErrorFieldList.push(JSON.parse(JSON.stringify(errorFieldObject)));
                startIndex++;
            });
            setErrorFieldList([...tempErrorFieldList]);
            setTotalNewTruckAgreements([...tempTotalNewTruckAgreements]);
            setNewTruckEditableAgreement([...tempNewTruckEditableAgreement]);
            setUserEditedTrucks({});
            setDeleteNewTruckList([]);
            setDeleteExistingTruckList([]);
            setShowDeleteAll(false);
            updateNewTruck([]);
        }
        setStartDate(initialStartDate);
        setEndDate(initialEndDate);
        resetDiscardFlag();
    }, [discardChanges]);

    useEffect(() => {
        if (executeDelete) {
            let tempDeleteNewTruckList = [...deleteNewTruckList];
            let tempDeleteExitingTruckList = [...deleteExistingTruckList];
            if (isNotEmptyList(tempDeleteNewTruckList)) {
                let tempNewTruck = [...newTruckAgreement];
                let deletedIndexList = [];
                if (isNotEmptyList(tempNewTruck)) {
                    tempNewTruck = tempNewTruck.filter((newAgreement, index) => {
                        if (tempDeleteNewTruckList.includes(index)) {
                            deletedIndexList.push(index);
                        }
                        return !tempDeleteNewTruckList.includes(index);
                    });
                    tempDeleteNewTruckList = tempDeleteNewTruckList.filter((deleteIndex) => {
                        return !deletedIndexList.includes(deleteIndex);
                    });
                    tempDeleteNewTruckList = tempDeleteNewTruckList.map((deleteIndex) => {
                        return deleteIndex - deletedIndexList.length;
                    });
                    updateNewTruck([...tempNewTruck]);
                    setDeleteNewTruckList([...tempDeleteNewTruckList]);
                }
            }

            if (isNotEmptyList(tempDeleteExitingTruckList)) {
                let agreementToDelete = get(agreements, `["${groupName}"][0]`, []);
                let groupDelete = false;
                if (
                    tempDeleteExitingTruckList.length ===
                    get(agreements, `["${groupName}"]`, [])?.length
                ) {
                    groupDelete = true;
                }
                deleteAgreement(
                    agreementToDelete.connection_id,
                    agreementToDelete.provider_id,
                    tempDeleteExitingTruckList,
                    groupName,
                    groupDelete,
                    deleteAllVehicles
                );
            } else {
                setExecuteDelete(false);
                setDeleteNewTruckList([]);
            }
        }
    }, [executeDelete]);

    useEffect(() => {
        if (changeStartDate) {
            let tempTruck = [...newTruckAgreement];
            let totalList = [...totalNewTruckAgreements];
            let tempEditedAgreements = {};
            if (isNotEmptyList(editedAgreements[groupName])) {
                tempEditedAgreements[groupName] = [...editedAgreements[groupName]];
            } else {
                tempEditedAgreements[groupName] = [];
            }
            let tempUserEditedTrucks = { ...userEditedTrucks };
            if (isEmptyList(Object.keys(tempUserEditedTrucks))) {
                tempUserEditedTrucks = {};
            }
            totalList.forEach((agreement, index) => {
                if (tempTruck.length > index) {
                    tempTruck[index].enabled_from = convertToUTCDateTimeString(startDate);
                    tempTruck[index].global_enabled_from = convertToUTCDateTimeString(startDate);
                } else {
                    agreement.enabled_from = convertToUTCDateTimeString(startDate);
                    agreement.global_enabled_from = convertToUTCDateTimeString(startDate);

                    if (isNotEmptyList(tempEditedAgreements[groupName])) {
                        let userEdited = tempEditedAgreements[groupName].find((editedTruckes) => {
                            return editedTruckes.id === agreement.id;
                        });
                        if (userEdited !== undefined) {
                            userEdited.enabled_from = convertToUTCDateTimeString(startDate);
                            userEdited.global_enabled_from = convertToUTCDateTimeString(startDate);
                        } else {
                            tempEditedAgreements[groupName].push(
                                JSON.parse(JSON.stringify(agreement))
                            );
                        }
                    } else {
                        tempEditedAgreements[groupName].push(JSON.parse(JSON.stringify(agreement)));
                    }
                    if (tempUserEditedTrucks.hasOwnProperty(agreement.id)) {
                        tempUserEditedTrucks[agreement.id].enabled_from =
                            convertToUTCDateTimeString(startDate);
                        tempUserEditedTrucks[agreement.id].global_enabled_from =
                            convertToUTCDateTimeString(startDate);
                    } else {
                        tempUserEditedTrucks[agreement.id] = JSON.parse(JSON.stringify(agreement));
                    }
                }
            });
            setUserEditedTrucks({ ...tempUserEditedTrucks });
            updateEditedAgreements(tempEditedAgreements);
            setTotalNewTruckAgreements([...totalList]);
            updateNewTruck([...tempTruck]);
            setChangeStartDate(false);
        }
    }, [startDate]);

    useEffect(() => {
        if (changeEndDate) {
            let tempTruck = [...newTruckAgreement];
            let totalList = [...totalNewTruckAgreements];
            let tempEditedAgreements = {};
            if (isNotEmptyList(editedAgreements[groupName])) {
                tempEditedAgreements[groupName] = [...editedAgreements[groupName]];
            } else {
                tempEditedAgreements[groupName] = [];
            }
            let tempUserEditedTrucks = { ...userEditedTrucks };
            if (isEmptyList(Object.keys(tempUserEditedTrucks))) {
                tempUserEditedTrucks = {};
            }
            totalList.forEach((agreement, index) => {
                if (tempTruck.length > index) {
                    tempTruck[index].expires_on = convertToUTCDateTimeString(endDate);
                    tempTruck[index].global_expires_on = convertToUTCDateTimeString(endDate);
                } else {
                    agreement.expires_on = convertToUTCDateTimeString(endDate);
                    agreement.global_expires_on = convertToUTCDateTimeString(endDate);

                    if (isNotEmptyList(tempEditedAgreements[groupName])) {
                        let userEdited = tempEditedAgreements[groupName].find((editedTruckes) => {
                            return editedTruckes.id === agreement.id;
                        });
                        if (userEdited !== undefined) {
                            userEdited.expires_on = convertToUTCDateTimeString(endDate);
                            userEdited.global_expires_on = convertToUTCDateTimeString(endDate);
                        } else {
                            tempEditedAgreements[groupName].push(
                                JSON.parse(JSON.stringify(agreement))
                            );
                        }
                    } else {
                        tempEditedAgreements[groupName].push(JSON.parse(JSON.stringify(agreement)));
                    }
                    if (tempUserEditedTrucks.hasOwnProperty(agreement.id)) {
                        tempUserEditedTrucks[agreement.id].expires_on =
                            convertToUTCDateTimeString(endDate);
                        tempUserEditedTrucks[agreement.id].global_expires_on =
                            convertToUTCDateTimeString(endDate);
                    } else {
                        tempUserEditedTrucks[agreement.id] = JSON.parse(JSON.stringify(agreement));
                    }
                }
            });
            setUserEditedTrucks({ ...tempUserEditedTrucks });
            updateEditedAgreements(tempEditedAgreements);
            setTotalNewTruckAgreements([...totalList]);
            updateNewTruck([...tempTruck]);
            setChangeEndDate(false);
        }
    }, [endDate]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setEmptyRows(
            rowsPerPage -
                Math.min(rowsPerPage, totalNewTruckAgreements.length - newPage * rowsPerPage)
        );
    };

    const setAgreementEditableStatus = (status) => {
        let groupEditMode = {};
        if (status) {
            groupEditMode[groupName] = status;
        }
        toggleAgreementEditStatus(groupEditMode);
    };

    const handleChangeRowsPerPage = (event) => {
        let changedRow = +event.target.value;
        setRowsPerPage(changedRow);
        setPage(0);
        setEmptyRows(changedRow - Math.min(changedRow, totalNewTruckAgreements.length));
    };

    useEffect(() => {
        setPage(0);
    }, [searchText]);

    useEffect(() => {
        setDeleteAllVehicles(
            deleteNewTruckList?.length === totalNewTruckAgreements?.length &&
                deleteNewTruckList?.length !== 0
        );
    }, [deleteNewTruckList, totalNewTruckAgreements]);

    const rendorRowEditable = (index) => {
        if (editedIndex === -1) {
            setErrorText('');
            setSelectedItem('');
            setEditedIndex(index);
            let tempEditRowMap = [...newTruckEditRowMap];
            tempEditRowMap[index] = true;
            setNewTruckEditRowMap([...tempEditRowMap]);
            setAgreementEditableStatus(true);
        }
    };

    const renderRowUneditable = (index) => {
        if (editedIndex !== -1) {
            setEditedIndex(-1);
            setIsEdited(false);
            let tempEditRowMap = [...newTruckEditRowMap];
            tempEditRowMap[index] = false;
            setNewTruckEditRowMap([...tempEditRowMap]);
            setCurrentSelected('');
            setErrorText('');
            setErrorField(JSON.parse(JSON.stringify(errorFieldProperties)));
            setAgreementEditableStatus(false);
        }
    };

    const validateTruckInfo = (index) => {
        setErrorText('');
        let existingTruckNumber;
        let editedAgreement = newTruckEditableAgreement[index];
        if ((selectedItem === '' && !isEdited) || selectedItem === editedAgreement.truck_number) {
            setCurrentSelected(editedAgreement.truck_number);
        } else {
            setIsEdited(true);
            if (selectedItem === '') {
                setSelectedItem(currentSelected);
            }
            existingTruckNumber = editedAgreement.truck_number;
            editedAgreement.truck_number = selectedItem;
            editedAgreement.truck_id = mobilityData.filter(
                (truck) => truck.truck_number === selectedItem
            )[0].vehicle_id;
            setCurrentSelected(selectedItem);
        }
        let errorTruckList = [];
        let errorTimingList = [];
        let errorEnteredTruckList = [];

        let errorDateTruckList = [];

        let error = {};

        if (errorField['enabled_from'].isInvalid || errorField['expires_on'].isInvalid) {
            errorDateTruckList.push(editedAgreement.truck_number);
        }
        if (errorDateTruckList.length === 0) {
            if (
                new Date(editedAgreement.enabled_from) > new Date(editedAgreement.expires_on) ||
                isEqualDate(editedAgreement.enabled_from, editedAgreement.expires_on)
            ) {
                errorTimingList.push(editedAgreement.truck_number);
            }
        }
        totalNewTruckAgreements.forEach((truck, totalIndex) => {
            if (editedAgreement.truck_number === truck.truck_number && totalIndex !== index) {
                errorTruckList.push(editedAgreement.truck_number);
            }
        });

        if (errorDateTruckList.length > 0) {
            error.inValidDates =
                errorDateTruckList.join(', ') + ' - You have entered invalid date(s)';
            setErrorText(error);
            return true;
        } else if (errorEnteredTruckList.length > 0) {
            error.duplicateTrucks =
                errorEnteredTruckList.join(', ') +
                ' - You have entered same Truck with same timings';
            setErrorText(error);
            return true;
        } else if (errorTimingList.length > 0 && errorTruckList.length > 0) {
            error.timing =
                errorTimingList.join(', ') +
                ' - Tracking Start is greater than Tracking End Timing';
            error.duplicateTrucks =
                errorTruckList.join(', ') +
                ' - An Agreement with entered Truck Information already exists!';
            setErrorText(error);
            return true;
        } else if (errorTimingList.length > 0) {
            error.duplicateTrucks = '';
            error.timing =
                errorTimingList.join(', ') +
                ' - Tracking Start is greater than Tracking End Timing';
            setErrorText(error);
            return true;
        } else if (errorTruckList.length > 0) {
            error.timing = '';
            error.duplicateTrucks =
                errorTruckList.join(', ') +
                ' - An Agreement with entered Truck Information already exists!';
            editedAgreement.truck_number = existingTruckNumber;
            setErrorText(error);
            return true;
        } else {
            setErrorText('');
            return false;
        }
    };

    const saveEditAgreement = (index) => {
        const isNotValid = validateTruckInfo(index);
        if (!isNotValid) {
            if (isNewTruckAgreementIndex(index)) {
                let tempUserAddedTrucks = [...newTruckAgreement];
                tempUserAddedTrucks[index] = {
                    ...newTruckEditableAgreement[index]
                };
                if (tempUserAddedTrucks[index].truck_number !== 'alltrucks') {
                    if (selectedItem !== '') {
                        tempUserAddedTrucks[index].truck_number = selectedItem;
                        tempUserAddedTrucks[index].truck_id = mobilityData.filter(
                            (truck) => truck.truck_number === selectedItem
                        )[0].vehicle_id;
                    }
                } else {
                    tempUserAddedTrucks[index].truck_number = 'alltrucks';
                    tempUserAddedTrucks[index].truck_id = 'alltrucks';
                }
                updateNewTruck([...tempUserAddedTrucks]);
            } else {
                let editedAgreement = newTruckEditableAgreement[index];

                if (editedAgreement.truck_number !== 'alltrucks') {
                    if (selectedItem !== '') {
                        editedAgreement.truck_number = selectedItem;
                        editedAgreement.truck_id = mobilityData.filter(
                            (truck) => truck.truck_number === selectedItem
                        )[0].vehicle_id;
                    }
                } else {
                    editedAgreement.truck_number = 'alltrucks';
                    editedAgreement.truck_id = 'alltrucks';
                }
                let tempExistingEditedAgreementList = { ...editedAgreements };
                let tempUserEditedTrucks = { ...userEditedTrucks };
                if (Object.keys(tempExistingEditedAgreementList).length === 0) {
                    tempExistingEditedAgreementList[groupName] = [];
                    tempExistingEditedAgreementList[groupName].push(editedAgreement);
                } else {
                    let editIndex = -1;
                    let alreadyEditedAgreement = tempExistingEditedAgreementList[groupName].find(
                        (agreement, index) => {
                            if (agreement.id === editedAgreement.id) {
                                editIndex = index;
                                return true;
                            }
                            return false;
                        }
                    );

                    if (
                        alreadyEditedAgreement !== undefined &&
                        Object.keys(alreadyEditedAgreement).length > 0
                    ) {
                        tempExistingEditedAgreementList[groupName][editIndex] = editedAgreement;
                    } else {
                        tempExistingEditedAgreementList[groupName].push(editedAgreement);
                    }
                }
                tempUserEditedTrucks[editedAgreement.id] = JSON.parse(
                    JSON.stringify(editedAgreement)
                );
                setUserEditedTrucks({ ...tempUserEditedTrucks });
                let tempTotalAgreements = [...totalNewTruckAgreements];
                tempTotalAgreements[index] = editedAgreement;
                setTotalNewTruckAgreements([...tempTotalAgreements]);
                updateEditedAgreements(tempExistingEditedAgreementList);
            }
            renderRowUneditable(index);
        }
    };

    const revertEditAgreement = (index) => {
        let tempUserAddedTrucks = [...newTruckEditableAgreement];
        let tempTotalAgreements = [...totalNewTruckAgreements];
        if (isNewTruckAgreementIndex(index)) {
            tempUserAddedTrucks[index] = {
                ...newTruckAgreement[index]
            };
        } else {
            let savedIndex = getExistingTruckAgreementIndex(index);
            if (userEditedTrucks.hasOwnProperty(tempUserAddedTrucks[index].id)) {
                tempUserAddedTrucks[index] = JSON.parse(
                    JSON.stringify(userEditedTrucks[tempUserAddedTrucks[index].id])
                );
                tempTotalAgreements[index] = JSON.parse(
                    JSON.stringify(userEditedTrucks[tempUserAddedTrucks[index].id])
                );
            } else {
                tempUserAddedTrucks[index] = JSON.parse(
                    JSON.stringify(get(agreements, `["${groupName}"][${savedIndex}]`, []))
                );
                tempTotalAgreements[index] = JSON.parse(
                    JSON.stringify(get(agreements, `["${groupName}"][${savedIndex}]`, []))
                );
            }
        }
        setNewTruckEditableAgreement([...tempUserAddedTrucks]);
        setTotalNewTruckAgreements([...tempTotalAgreements]);
        renderRowUneditable(index);
    };

    const isNewTruckAgreementIndex = (index) => {
        return isNotEmptyList(newTruckAgreement) && newTruckAgreement.length - 1 >= index;
    };

    const getExistingTruckAgreementIndex = (index) => {
        let savedIndex = index;
        if (isNotEmptyList(newTruckAgreement) && newTruckAgreement.length - 1 - 1 < index) {
            savedIndex = index - newTruckAgreement.length;
        }
        return savedIndex;
    };
    const deleteTruck = (index) => {
        if (isNewTruckAgreementIndex(index)) {
            let tempUserAddedTrucks = [...newTruckAgreement];
            tempUserAddedTrucks.splice(index, 1);
            updateNewTruck(tempUserAddedTrucks);
            if (isNotEmptyList(deleteNewTruckList)) {
                let tempDeleteNewTruckList = [...deleteNewTruckList];
                tempDeleteNewTruckList = tempDeleteNewTruckList.filter((seletedAgreementIndex) => {
                    return seletedAgreementIndex !== index;
                });
                if (isEmptyList(tempDeleteNewTruckList)) {
                    setShowDeleteAll(false);
                } else {
                    tempDeleteNewTruckList = tempDeleteNewTruckList.map((seletedAgreementIndex) => {
                        if (seletedAgreementIndex > index) {
                            return seletedAgreementIndex - 1;
                        }
                        return seletedAgreementIndex;
                    });
                }
                setDeleteNewTruckList([...tempDeleteNewTruckList]);
            }
            const totalPage = Math.ceil(totalNewTruckAgreements.length / rowsPerPage) - 1;
            if (totalNewTruckAgreements.length % rowsPerPage === 1 && page === totalPage) {
                if (page - 1 >= 0) {
                    setPage(page - 1);
                }
            }
        } else {
            let savedIndex = getExistingTruckAgreementIndex(index);
            let agreementToDelete = get(agreements, `["${groupName}"][${savedIndex}]`, []);
            let groupDelete = false;
            if (get(agreements, `["${groupName}"]`, [])?.length === 1) {
                groupDelete = true;
            }
            deleteAgreement(
                agreementToDelete.connection_id,
                agreementToDelete.provider_id,
                [agreementToDelete.id],
                agreementToDelete.group_name,
                groupDelete,
                deleteAllVehicles
            );
        }
        openConfirmationDialog(false, -1);
    };

    const handleChange = (item) => {
        setSelectedItem(item);
        setShowSuggestions(false);
    };

    const isNoTruckFound = mobilityData.length === 0;

    const getSuggestions = (value) => {
        let inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;

        let vehicleData = mobilityData.map((truck) => truck.truck_number);

        return inputLength === 0
            ? []
            : vehicleData.filter((suggestion) => {
                  return suggestion.toString().slice(0, inputLength).toLowerCase() === inputValue;
              });
    };

    const renderInput = (inputProps) => {
        const { InputProps, classes, ref, ...other } = inputProps;

        return (
            <TextField
                onBlur={() => toggleTruckSearch()}
                InputProps={{
                    inputRef: ref,
                    classes: {
                        root: css.inputRoot,
                        input: css.inputInput
                    },
                    ...InputProps
                }}
                {...other}
            />
        );
    };

    const handleErrorDateChange = (index, fieldName) => (date) => {
        let tempErrorField = { ...errorField };
        if (fieldName === 'enabled_from') {
            tempErrorField[fieldName].isInvalid = true;
        } else {
            tempErrorField[fieldName].isInvalid = true;
        }
        setErrorField({ ...tempErrorField });
        validateTruckInfo(index);
    };

    const handleBlankDateInAgreement = (index, fieldName) => (event) => {
        if (event.target.value === '') {
            let tempUserAddedTrucks = JSON.parse(JSON.stringify(newTruckEditableAgreement));
            let tempUserAddedTrucksMask = JSON.parse(JSON.stringify(newTruckEditableAgreement));
            tempUserAddedTrucksMask[index][fieldName] = convertToDateTimeString(
                newTruckEditableAgreement[index][fieldName]
            );
            setNewTruckEditableAgreement(JSON.parse(JSON.stringify(tempUserAddedTrucksMask)));
            setTimeout(() => {
                setNewTruckEditableAgreement(JSON.parse(JSON.stringify(tempUserAddedTrucks)));
            }, 1);
        }
        setDisableTick(false);
    };

    const handleDateChange = (index, fieldName) => (date) => {
        let tempUserAddedTrucks = [...newTruckEditableAgreement];
        tempUserAddedTrucks[index][fieldName] =
            convertLocalDateTimePickerFormatStringFromDateObject(convertToUTCDateTimeString(date));
        setNewTruckEditableAgreement([...tempUserAddedTrucks]);
        let tempErrorField = { ...errorField };
        tempErrorField[fieldName].isInvalid = false;
        setErrorField({ ...tempErrorField });
    };

    const toggleTruckSearch = () => {
        if (!isNoTruckFound && isValidDefaultStartDate && isValidDefaultEndDate) {
            setShowSearchTruck(!showSearchTruck);
        }
    };

    const toggleDateField = (fieldName, index) => {
        if (newTruckEditableAgreement[index] && newTruckEditableAgreement[index][fieldName]) {
            let agreementField = convertLocalDateString(
                newTruckEditableAgreement[index][fieldName]
            );
            if (agreementField !== undefined) {
                return (
                    <MuiThemeProvider theme={DEFAULT_THEME}>
                        <DatePicker
                            keyboard
                            id={fieldName}
                            name={fieldName}
                            format={'MM/dd/yyyy'}
                            showTodayButton
                            onError={handleErrorDateChange(index, fieldName)}
                            onChange={handleDateChange(index, fieldName)}
                            onInputChange={() => setDisableTick(true)}
                            onBlur={handleBlankDateInAgreement(index, fieldName)}
                            value={agreementField}
                            InputLabelProps={{
                                shrink: true
                            }}
                            disableOpenOnEnter
                            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                        />
                    </MuiThemeProvider>
                );
            }
            return <div>{formatDefaultStringDate(agreementField)}</div>;
        }
    };

    const toggleTruckSearchComponent = (fieldName, index) => {
        if (newTruckEditableAgreement[index] && newTruckEditableAgreement[index][fieldName]) {
            let agreementField = newTruckEditableAgreement[index][fieldName];
            const renderSuggestion = (groupNamesSuggestion, index, itemProps, highlightedIndex) => {
                const isHighlighted = highlightedIndex === index;

                return (
                    <MenuItem
                        {...itemProps}
                        key={groupNamesSuggestion}
                        selected={isHighlighted}
                        component="div"
                        style={{
                            fontWeight: 400,
                            overflowY: 'auto'
                        }}
                    >
                        {groupNamesSuggestion}
                    </MenuItem>
                );
            };

            renderSuggestion.propTypes = {
                highlightedIndex: PropTypes.number,
                index: PropTypes.number,
                itemProps: PropTypes.object,
                selectedItem: PropTypes.string,
                suggestion: PropTypes.shape({ label: PropTypes.string }).isRequired
            };

            return (
                <Downshift
                    id="downshift-simple"
                    onChange={handleChange}
                    selectedItem={selectedItem === '' ? agreementField : selectedItem}
                >
                    {({
                        getInputProps,
                        getItemProps,
                        getMenuProps,
                        highlightedIndex,
                        inputValue,
                        selectedItem
                    }) => (
                        <div className={css.container}>
                            {renderInput({
                                fullWidth: true,
                                InputProps: getInputProps({
                                    onFocus: (event) => {
                                        setShowSuggestions(true);
                                    }
                                })
                            })}
                            <div {...getMenuProps()}>
                                {inputValue.trim() !== '' &&
                                inputValue !== selectedItem &&
                                showSuggestions ? (
                                    <Paper className={css.dropDownPaper} square>
                                        {getSuggestions(inputValue).map((suggestion, index) =>
                                            renderSuggestion(
                                                suggestion,
                                                index,
                                                getItemProps({ item: suggestion }),
                                                highlightedIndex
                                            )
                                        )}
                                    </Paper>
                                ) : null}
                            </div>
                        </div>
                    )}
                </Downshift>
            );
        }
    };

    const formatDefaultStringDate = (date) => {
        return format(date, 'MM/dd/yyyy hh:mm a');
    };

    const disableSave = () => {
        let inValid = false;
        if (disableOtherOperation || disableTick) {
            return true;
        }
        return inValid;
    };

    const toggleTruckSelection = (index) => {
        let tempDeleteNewTruckList = [...deleteNewTruckList];
        if (tempDeleteNewTruckList.includes(index)) {
            tempDeleteNewTruckList = tempDeleteNewTruckList.filter((deleteIndex) => {
                return deleteIndex !== index;
            });
        } else {
            tempDeleteNewTruckList.push(index);
        }
        setDeleteNewTruckList([...tempDeleteNewTruckList]);
        if (tempDeleteNewTruckList.length > 0) {
            setShowDeleteAll(true);
        } else {
            setShowDeleteAll(false);
        }
        if (isNotBlank(totalNewTruckAgreements[index].id)) {
            let tempDeleteExitingTruckList = [...deleteExistingTruckList];
            if (tempDeleteExitingTruckList.includes(totalNewTruckAgreements[index].id)) {
                tempDeleteExitingTruckList = tempDeleteExitingTruckList.filter((deleteId) => {
                    return deleteId !== totalNewTruckAgreements[index].id;
                });
            } else {
                tempDeleteExitingTruckList.push(totalNewTruckAgreements[index].id);
            }
            setDeleteExistingTruckList([...tempDeleteExitingTruckList]);
        }
    };

    const handleSelectAll = (event) => {
        if (totalNewTruckAgreements.length !== deleteNewTruckList.length) {
            let tempTotalDeleteList = [];
            tempTotalDeleteList = totalNewTruckAgreements.map((agreement, index) => {
                return index;
            });
            setDeleteNewTruckList([...tempTotalDeleteList]);
            let tempTotalExisingDeleteList = [];
            tempTotalExisingDeleteList = totalNewTruckAgreements
                .filter((agreement, index) => {
                    return isNotBlank(agreement.id);
                })
                .map((agreement, index) => {
                    return agreement.id;
                });
            setDeleteExistingTruckList([...tempTotalExisingDeleteList]);
            setShowDeleteAll(true);
        } else {
            setDeleteNewTruckList([]);
            setDeleteExistingTruckList([]);
            setShowDeleteAll(false);
        }
    };

    const openConfirmationDialog = (closeDialog, index) => {
        setOpenConfimation(closeDialog);
        setDeleteIndex(index);
    };

    const disableFieldAndButton = () => {
        return (
            !isWriteAccessGranted ||
            disableOtherOperation ||
            isOtherGroupInEditMode(
                newAgreementGroup,
                existingAgreementGroup,
                editedAgreements,
                newShipperAgreement,
                groupName,
                isAgreementInEditMode,
                newTruckAgreement
            )
        );
    };

    const dialogAction = (
        <div>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME}>
                <Button component="span" onClick={() => openConfirmationDialog(false, -1)}>
                    No
                </Button>
            </MuiThemeProvider>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                <Button component="span" onClick={() => deleteTruck(deleteIndex)}>
                    Yes
                </Button>
            </MuiThemeProvider>
        </div>
    );

    return (
        <Auxiliary>
            <MuiThemeProvider theme={!hideLocalElement ? TABLE_THEME : TABLE_THEME_ALT}>
                <TableContainer className={agreementCSS.agreementTable}>
                    <Table stickyHeader>
                        <TableHead className={agreementCSS.agreementTableHeader}>
                            <TableRow>
                                {!hideLocalElement && (
                                    <TableCell>
                                        <Checkbox
                                            onChange={handleSelectAll}
                                            disabled={
                                                disableFieldAndButton() || !isDeleteAccessGranted
                                            }
                                            checked={
                                                deleteNewTruckList.length ===
                                                    totalNewTruckAgreements.length &&
                                                deleteNewTruckList.length !== 0
                                            }
                                            classes={CHECKBOX_STYLE}
                                        />
                                    </TableCell>
                                )}
                                <TableCell align="left">Truck ID</TableCell>
                                <TableCell align="left">Status</TableCell>
                                <TableCell align="left">Tracking Start</TableCell>
                                <TableCell align="left">Tracking End</TableCell>
                                {!hideLocalElement && <TableCell align="left">Actions</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {totalNewTruckAgreements
                                .slice(rowsPerPage * page, page * rowsPerPage + rowsPerPage)
                                .map((agreement, index) =>
                                    editedIndex !== page * rowsPerPage + index ? (
                                        <TableRow
                                            key={page * rowsPerPage + index}
                                            id={agreement.truck_number}
                                        >
                                            {!hideLocalElement && (
                                                <TableCell>
                                                    <Checkbox
                                                        disabled={
                                                            disableFieldAndButton() ||
                                                            !isDeleteAccessGranted
                                                        }
                                                        checked={deleteNewTruckList.includes(
                                                            page * rowsPerPage + index
                                                        )}
                                                        onChange={() =>
                                                            toggleTruckSelection(
                                                                page * rowsPerPage + index
                                                            )
                                                        }
                                                        classes={CHECKBOX_STYLE}
                                                    />
                                                </TableCell>
                                            )}
                                            <TableCell align="left">
                                                {agreement.truck_number}
                                            </TableCell>
                                            <TableCell align="left">
                                                {agreement.status ? 'ACTIVE' : 'INACTIVE'}
                                            </TableCell>
                                            <TableCell align="left">
                                                {convertLocalDateString(agreement.enabled_from)}
                                            </TableCell>
                                            <TableCell align="left">
                                                {convertLocalDateString(agreement.expires_on)}
                                            </TableCell>
                                            {!hideLocalElement && (
                                                <TableCell align="left">
                                                    <IconButton
                                                        id={'edit-shipper'}
                                                        onClick={() =>
                                                            rendorRowEditable(
                                                                page * rowsPerPage + index
                                                            )
                                                        }
                                                        classes={{
                                                            disabled: baseCSS.disabledIconButton
                                                        }}
                                                        disabled={
                                                            disableFieldAndButton() ||
                                                            editedIndex >= 0
                                                        }
                                                    >
                                                        <i
                                                            className={cs(
                                                                'fas fa-pen',
                                                                css.iconButton
                                                            )}
                                                        />
                                                    </IconButton>
                                                    <IconButton
                                                        id={'delete-shipper'}
                                                        onClick={() =>
                                                            openConfirmationDialog(
                                                                true,
                                                                page * rowsPerPage + index
                                                            )
                                                        }
                                                        classes={{
                                                            disabled: baseCSS.disabledIconButton
                                                        }}
                                                        disabled={
                                                            disableFieldAndButton() ||
                                                            !isDeleteAccessGranted ||
                                                            editedIndex >= 0
                                                        }
                                                    >
                                                        <i
                                                            className={cs(
                                                                'fas fa-trash',
                                                                css.iconButton
                                                            )}
                                                        />
                                                    </IconButton>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    ) : (
                                        <>
                                            <TableRow key={page * rowsPerPage + index}>
                                                {!hideLocalElement && (
                                                    <TableCell>
                                                        <Checkbox
                                                            disabled={
                                                                disableFieldAndButton() ||
                                                                !isDeleteAccessGranted
                                                            }
                                                            checked={deleteNewTruckList.includes(
                                                                page * rowsPerPage + index
                                                            )}
                                                            onChange={() =>
                                                                toggleTruckSelection(
                                                                    page * rowsPerPage + index
                                                                )
                                                            }
                                                            classes={CHECKBOX_STYLE}
                                                        />
                                                    </TableCell>
                                                )}
                                                <TableCell align="left">
                                                    {agreement.truck_number === 'alltrucks'
                                                        ? agreement.truck_number
                                                        : toggleTruckSearchComponent(
                                                              'truck_number',
                                                              page * rowsPerPage + index
                                                          )}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {agreement.status ? 'ACTIVE' : 'INACTIVE'}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {toggleDateField(
                                                        'enabled_from',
                                                        page * rowsPerPage + index
                                                    )}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {toggleDateField(
                                                        'expires_on',
                                                        page * rowsPerPage + index
                                                    )}
                                                </TableCell>
                                                {!hideLocalElement && (
                                                    <TableCell align="left">
                                                        <IconButton
                                                            id={'check-shipper'}
                                                            disabled={disableSave()}
                                                            classes={{
                                                                disabled: baseCSS.disabledIconButton
                                                            }}
                                                            onClick={() => {
                                                                saveEditAgreement(
                                                                    page * rowsPerPage + index
                                                                );
                                                            }}
                                                        >
                                                            <i
                                                                className={cs(
                                                                    'fas fa-check',
                                                                    css.iconButton
                                                                )}
                                                            />
                                                        </IconButton>
                                                        <IconButton
                                                            id={'close-shipper'}
                                                            onClick={() => {
                                                                revertEditAgreement(
                                                                    page * rowsPerPage + index
                                                                );
                                                            }}
                                                        >
                                                            <i
                                                                className={cs(
                                                                    'fas fa-times',
                                                                    css.iconButton
                                                                )}
                                                            />
                                                        </IconButton>
                                                    </TableCell>
                                                )}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell colSpan={6}>
                                                    <FormHelperText style={{ color: 'red' }}>
                                                        <div>{errorText.truckNumber}</div>
                                                        <div>{errorText.inValidDates}</div>
                                                        <div>{errorText.timing}</div>
                                                        <div>{errorText.duplicateTrucks}</div>
                                                    </FormHelperText>
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    )
                                )}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 40 * emptyRows, background: '#e5e5e5' }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </MuiThemeProvider>
            <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={totalNewTruckAgreements.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                    'aria-label': 'previous page'
                }}
                nextIconButtonProps={{
                    'aria-label': 'next page'
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            <TDialog
                id={'cancel_request'}
                open={openConfimation}
                handleClose={() => openConfirmationDialog(false)}
                dialogContentText={'Are you sure you want to delete the Truck?'}
                dialogTitle={'Confirmation'}
                dialogActions={dialogAction}
            />
        </Auxiliary>
    );
};

const mapStateToProps = (state) => {
    return {
        newTruckAgreement: state.agreement.newTruckAgreements,
        agreements:
            state.agreement.searchText === ''
                ? state.agreement.agreements
                : state.agreement.filteredAgreements,
        searchText: state.agreement.searchText,
        mobilityData: state.agreement.mobilityData,
        editedAgreements: state.agreement.editedAgreements,
        deletedAgreements: state.agreement.deletedAgreements,
        discardChanges: state.agreement.discardChanges,
        newShipperAgreement: state.agreement.newShipperAgreement,
        newAgreementGroup: state.agreement.newAgreementGroup,
        existingAgreementGroup: state.agreement.existingAgreementGroup,
        isAgreementInEditMode: state.agreement.isAgreementInEditMode,
        disableOtherOperation: state.agreement.disableOtherOperation,
        sidebarResource: state.header.sidebarResource
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateNewTruck: (agreements) => dispatch(actions.updateNewTruck(agreements)),
        updateEditedAgreements: (editedExistingAgreements) => {
            dispatch(actions.updateEditedAgreements(editedExistingAgreements));
        },
        deleteAgreement: (
            connectionId,
            provider,
            agreementIdList,
            groupName,
            groupDelete,
            deleteAllVehicles
        ) => {
            dispatch(
                actions.deleteAgreement(
                    connectionId,
                    provider,
                    agreementIdList,
                    groupName,
                    Constants.AGREEMENT_TRUCK,
                    groupDelete,
                    deleteAllVehicles
                )
            );
        },
        updateDeletedAgreements: (agreementIdList) => {
            dispatch(actions.updateDeletedAgreements(agreementIdList));
        },
        toggleAgreementEditStatus: (status) => dispatch(actions.toggleAgreementEditStatus(status)),
        resetDiscardFlag: () => dispatch(actions.discardChanges(false))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TruckAgreements));
